import { HttpStatusCode } from 'axios'
import { useEffect } from 'react'

import { orderFormDataComponentService } from '@/modules/order/services/order-form-data-component.service'
import { useToast } from '@/modules/shared/hooks/use-toast'
import { useAxiosHttpClient } from '@/modules/shared/infra/axios-http-client.infra'
import type { PayloadSearch } from '@/modules/shared/types/payload-search.type'

import {
  useScheduleFormStore,
  useScheduleFormStoreActions,
} from '../stores/schedule-form.store'

export function useCustomerSelectionSchedule() {
  const { toast } = useToast()

  const { axiosRequest: requestClient } = useAxiosHttpClient({
    sendRequest: orderFormDataComponentService,
  })

  const { isOpenModalCustomer } = useScheduleFormStore()
  const { setCustomers, setIsOpenModalCustomer } = useScheduleFormStoreActions()

  const handleSearchClient = ({ payload }: PayloadSearch) => {
    const newPayload = {
      entityType: '1',
      filter: payload.filter,
      inputValue:
        payload.filter === 'cnpjcpf' || payload.filter === 'id_entidade'
          ? payload.inputValue.replace(/\D/g, '')
          : payload.inputValue,
    }

    if (newPayload.inputValue.length <= 0) {
      toast.info({
        title: 'Insira algum valor ou verifique o filtro selecionado.',
      })
      return
    }

    setIsOpenModalCustomer(true)

    requestClient.mutate({
      payload: newPayload,
      showInfo: true,
    })
  }

  useEffect(() => {
    if (requestClient.isSuccess) {
      if (requestClient.data.status === HttpStatusCode.Ok) {
        setCustomers(JSON.parse(requestClient.data.body))
        return
      }

      setIsOpenModalCustomer(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestClient.isLoading])

  return {
    isOpenModalCustomer,
    isLoadingRequestClient: requestClient.isLoading,
    handleSearchClient,
  }
}
